var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__(
        "activities.listing.massActions.ActivitiesListingMassReschedule.reschedule_activities_title"
      ),
      primaryAction: {
        label: _vm.$t.__("common.actions.confirm"),
        action: function() {
          return _vm.confirmMassReschedule()
        },
        loading: _vm.isSubmitting,
        disabled: _vm.isDateInvalid
      },
      secondaryActions: [
        {
          label: _vm.$t.__("common.actions.cancel"),
          action: function() {
            return _vm.$emit("close")
          }
        }
      ]
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "span",
              {
                staticClass:
                  "typographies-paragraph-medium-regular mass-reschedule-text"
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.textContent) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("CompassCalendar", {
              attrs: {
                disableWeekDays: _vm.disabledWeekDays,
                lang: _vm.uiLang
              },
              model: {
                value: _vm.selectedDate,
                callback: function($$v) {
                  _vm.selectedDate = $$v
                },
                expression: "selectedDate"
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }